// Copyright (C) 2021 Fair Supply Analytics Pty Ltd - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  type: 'demo',
  server: {
    apiURL: 'https://demo-api.fairsupply.io/api/v1',
    rssURL: 'https://demo-api.fairsupply.io/rss-feed',
    // TODO: for demo env, where should we link to in Analyst? ATM, link to production Analyst. This allows user to sign up for trial account.
    // But most likely can't link to existing Auth0 Organisation from demo (diff. Auth0 tenants). Also demo env shouldn't have actual users with real Auth0 Orgs. to maintain.
    analystAppURL: 'https://app.fairsupply.com/landing',
  },
  auth: {
    audience: 'https://api.fairsupplyanalytics-demo.com',
    clientId: 'LeO8IpbZgR4cfkvcrCYSlbfsk6hSMTuO',
    domain: 'fairsupplyanalytics-demo.au.auth0.com',
    namespace: 'https://fairsupplyanalytics-demo.com/roles',
  },
  defaultPageTitle: 'FairSupply - Demo',
  analytics: {
    ga: {
      enabled: false,
      id: '',
    },
    gtm: {
      enabled: false,
      id: '',
    },
    segment: {
      enabled: true,
      id: 'aWqpY1QkJoTm5AaSEnmJNlqNvtzD0Jn6',
    },
    app: 'FairSupply',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
